import React from 'react';

/**
 * Logo TradIA — SVG inspirado en el brandbook (hexágono con nodos + flecha
 * ascendente). Usa gradiente azul profundo → turquesa. Sin texto por defecto;
 * activa `withWordmark` para composición completa.
 */
export function LogoIsotype({ size = 28, className = '', title = 'TradIA' }) {
  const id = React.useId();
  const g1 = `${id}-g1`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className={className}
      data-testid="tradia-isotype"
    >
      <defs>
        <linearGradient id={g1} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0B2E6D" />
          <stop offset="0.5" stopColor="#1F78FF" />
          <stop offset="1" stopColor="#1ED4C3" />
        </linearGradient>
      </defs>
      {/* Hexágono exterior */}
      <path
        d="M32 3 L57 17.5 L57 46.5 L32 61 L7 46.5 L7 17.5 Z"
        fill="none"
        stroke={`url(#${g1})`}
        strokeWidth="3"
        strokeLinejoin="round"
      />
      {/* Red interna */}
      <g stroke={`url(#${g1})`} strokeWidth="2" strokeLinecap="round">
        <line x1="20" y1="22" x2="32" y2="29" />
        <line x1="32" y1="29" x2="44" y2="22" />
        <line x1="32" y1="29" x2="32" y2="43" />
        <line x1="32" y1="43" x2="20" y2="48" />
        <line x1="32" y1="43" x2="44" y2="48" />
      </g>
      <g fill={`url(#${g1})`}>
        <circle cx="20" cy="22" r="2.6" />
        <circle cx="32" cy="29" r="2.6" />
        <circle cx="44" cy="22" r="2.6" />
        <circle cx="32" cy="43" r="2.6" />
        <circle cx="20" cy="48" r="2.6" />
        <circle cx="44" cy="48" r="2.6" />
      </g>
      {/* Flecha ascendente */}
      <path
        d="M14 44 L28 34 L38 39 L50 22"
        fill="none"
        stroke="#1ED4C3"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 22 L44 22 M50 22 L50 28"
        stroke="#1ED4C3"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LogoLockup({ size = 32, className = '', tagline }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="tradia-lockup">
      <LogoIsotype size={size} />
      <div className="leading-none">
        <div
          className="font-display font-semibold text-[17px] brand-gradient-text"
          style={{ letterSpacing: '-0.01em' }}
          data-testid="tradia-wordmark"
        >
          TradIA
        </div>
        {tagline && (
          <div className="text-[10.5px] uppercase tracking-[0.14em] text-muted-foreground mt-1">
            {tagline}
          </div>
        )}
      </div>
    </div>
  );
}

export default LogoLockup;
